import React, { Fragment } from 'react';
import { PurefloTheme, WaterRegionalTheme } from 'components/ThemeProvider';
import PurefloCart from './Pureflo';
import WaterCart from './Water';

const Cart = (props) => (
  <Fragment>
    <PurefloTheme>
      <PurefloCart {...props} />
    </PurefloTheme>
    <WaterRegionalTheme>
      <WaterCart {...props} />
    </WaterRegionalTheme>
  </Fragment>
);

export default Cart;
